import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { LOGO } from '../../constants/imageTemplateStrings';
import styles from './OwnerImageLink.scss';

interface OwnerImageLinkProps {
  ownerUrl: string;
  logo: string;
  name: string;
  qaIdentifier?: string;
  itemProp?: string;
  logoTemplate?: string;
  variant?: 'normal' | 'mini';
}

export const OwnerImageLink: FunctionComponent<OwnerImageLinkProps> = ({
  ownerUrl,
  logo,
  name,
  qaIdentifier,
  itemProp,
  logoTemplate = LOGO,
  variant = 'normal',
}) => (
  <a
    data-qa={qaIdentifier}
    href={ownerUrl}
    tabIndex={-1}
    itemProp={itemProp}
    className={classNames(
      styles.link,
      variant === 'mini' && styles.mini,
      'jg-space-mbmd',
    )}
  >
    <img
      className={styles.image}
      src={`${logo}?template=${logoTemplate}`}
      alt=""
    />
    <span className="jg-sr-only">{name}</span>
  </a>
);
